import axios from 'axios';

const list = (page = 0, pagesize = 16) => {
    return axios({
        method: 'get',
        url: `${ process.env.VUE_APP_API_URL }/Notifications/?pageSize=${ pagesize }&page=${ page }`,
        withCredentials: true,
    });
};

const item = (id) => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Notifications/Details/${ id }`,
    withCredentials: true,
});

const create = (element) => {
    const json = { ...element };
    json.countryIds = json.countryIds.map((country) => country.id);

    const data = new FormData();
    data.set('data', JSON.stringify(json));

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/Notifications/Create`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const update = (id, element) => {
    const { icon, image, ...json } = element;

    const data = new FormData();
    data.set('data', JSON.stringify(json));
    if (typeof icon !== 'undefined' && icon) {
        data.append('icon', icon);
    }
    if (typeof image !== 'undefined' && image) {
        data.append('image', image);
    }

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/Notifications/Update/${ id }`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const remove = (id) => axios({
    method: 'delete',
    url: `${ process.env.VUE_APP_API_URL }/Notifications/Delete/${ id }`,
    withCredentials: true,
});

export default {
    list,
    item,
    create,
    update,
    remove,
};
